import { createContext } from "react";

const DadosContextFornecedor = createContext();

export default DadosContextFornecedor;
